import { render, staticRenderFns } from "./CompetencePreview.vue?vue&type=template&id=7f9076e1&scoped=true"
import script from "./CompetencePreview.vue?vue&type=script&lang=js"
export * from "./CompetencePreview.vue?vue&type=script&lang=js"
import style0 from "./CompetencePreview.vue?vue&type=style&index=0&id=7f9076e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9076e1",
  null
  
)

export default component.exports